import { getTranslatedText, ALL_SHARD_MODULES } from '@nile/components';

const getDefaultCustomFields = (intl, module) => {
  const DEFAULT_CUSTOM_FIELDS = [
    {
      label: getTranslatedText(intl, 'admin.formbuilder.create.shortText'),
      value: 'TEXT',
      id: 0
    },
    {
      label: getTranslatedText(intl, 'client.new.addField.long'),
      value: 'PARAGRAPH',
      id: 1
    },
    {
      label: getTranslatedText(intl, 'admin.CustomFields.create.op.number'),
      value: 'NUMERIC',
      id: 2
    },
    {
      label: getTranslatedText(intl, 'admin.CustomFields.create.op.decimal'),
      value: 'DECIMAL',
      id: 3
    },
    {
      label: getTranslatedText(intl, 'admin.CustomFields.create.op.date'),
      value: 'DATE',
      id: 4
    },
    {
      label: getTranslatedText(intl, 'admin.CustomFields.create.op.dateTime'),
      value: 'DATETIME',
      id: 5
    },
    {
      label: getTranslatedText(intl, 'admin.CustomFields.create.op.radio'),
      value: 'RADIO',
      id: 6
    },
    {
      label: getTranslatedText(intl, 'admin.CustomFields.create.op.checkbox'),
      value: 'CHECKBOX',
      id: 7
    },
    {
      label: getTranslatedText(intl, 'admin.CustomFields.create.op.select'),
      value: 'SELECT',
      id: 8
    },
    {
      label: getTranslatedText(intl, 'admin.CustomFields.create.op.multi'),
      value: 'MULTI_SELECT',
      id: 9
    }
  ];

  if (module === ALL_SHARD_MODULES.invoice) {
    return [
      {
        label: getTranslatedText(intl, 'admin.formbuilder.create.shortText'),
        value: 'TEXT',
        id: 0
      }
    ];
  }

  return DEFAULT_CUSTOM_FIELDS;
};

const DEPENDENT_FIELD_OPTION = ['SELECT', 'RADIO'];

export { getDefaultCustomFields, DEPENDENT_FIELD_OPTION };
